import { createStore, combineReducers } from 'redux';
// import doReducer from './views/DeliveryOrder/doReducer';
import approvalReducer from './views/approval-center/approvalReducer';
import poReducer from './views/po/POReducer';
import menuReducer from './views/pages/login/menu.reducer'
import PrRfqReducer from './views/pr/prRfqReducer';
// import requisitionReducer from './views/pr/PRReducer';
import resetPwdReducer from './views/pages/login/resetPwdReducer';

const initialState = {
  sidebarShow: false,
  selectedMenuItem:{}
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return {...state, ...rest }
    default:
      return state
  }
};

const rootReducer = combineReducers({
  changeState,
  // doReducer,
  resetPwdReducer,
  poReducer,
  approvalReducer,
  prRfqReducer: PrRfqReducer,
  menuReducer
})

const store = createStore(rootReducer);
// const store = createStore(changeState);
export default store;